import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';

import { Quote } from '../models/quote';

@Component({
  selector: 'app-quote-status-icon',
  templateUrl: './quote-status-icon.component.html',
  styleUrls: ['./quote-status-icon.component.scss'],
})
export class QuoteStatusIconComponent implements OnInit {

  @Input() quote?: Quote;
  //@ViewChild('childComponentTemplate') childComponentTemplate: TemplateRef<any>;
  @ViewChild('childComponentTemplate', { static: true }) childComponentTemplate: TemplateRef<any>;

  constructor() { }

  ngOnInit() {}

}
